module.exports = __webpack_public_path__ + "static/media/field01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/fields/field01.svg
// module id = 64
// module chunks = 0